import { __require as C } from "../../prop-types/index.js";
var y, h;
function R() {
  if (h) return y;
  h = 1;
  var m = Object.create, c = Object.defineProperty, g = Object.getOwnPropertyDescriptor, w = Object.getOwnPropertyNames, O = Object.getPrototypeOf, k = Object.prototype.hasOwnProperty, I = (t, s) => {
    for (var i in s)
      c(t, i, { get: s[i], enumerable: !0 });
  }, b = (t, s, i, _) => {
    if (s && typeof s == "object" || typeof s == "function")
      for (let f of w(s))
        !k.call(t, f) && f !== i && c(t, f, { get: () => s[f], enumerable: !(_ = g(s, f)) || _.enumerable });
    return t;
  }, S = (t, s, i) => (i = t != null ? m(O(t)) : {}, b(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !t || !t.__esModule ? c(i, "default", { value: t, enumerable: !0 }) : i,
    t
  )), V = (t) => b(c({}, "__esModule", { value: !0 }), t), v = {};
  I(v, {
    defaultProps: () => D,
    propTypes: () => E
  }), y = V(v);
  var x = S(/* @__PURE__ */ C());
  const { string: o, bool: n, number: p, array: d, oneOfType: u, shape: l, object: a, func: e, node: P } = x.default, E = {
    url: u([o, d, a]),
    playing: n,
    loop: n,
    controls: n,
    volume: p,
    muted: n,
    playbackRate: p,
    width: u([o, p]),
    height: u([o, p]),
    style: a,
    progressInterval: p,
    playsinline: n,
    pip: n,
    stopOnUnmount: n,
    light: u([n, o, a]),
    playIcon: P,
    previewTabIndex: p,
    previewAriaLabel: o,
    fallback: P,
    oEmbedUrl: o,
    wrapper: u([
      o,
      e,
      l({ render: e.isRequired })
    ]),
    config: l({
      soundcloud: l({
        options: a
      }),
      youtube: l({
        playerVars: a,
        embedOptions: a,
        onUnstarted: e
      }),
      facebook: l({
        appId: o,
        version: o,
        playerId: o,
        attributes: a
      }),
      dailymotion: l({
        params: a
      }),
      vimeo: l({
        playerOptions: a,
        title: o
      }),
      mux: l({
        attributes: a,
        version: o
      }),
      file: l({
        attributes: a,
        tracks: d,
        forceVideo: n,
        forceAudio: n,
        forceHLS: n,
        forceSafariHLS: n,
        forceDisableHls: n,
        forceDASH: n,
        forceFLV: n,
        hlsOptions: a,
        hlsVersion: o,
        dashVersion: o,
        flvVersion: o
      }),
      wistia: l({
        options: a,
        playerId: o,
        customControls: d
      }),
      mixcloud: l({
        options: a
      }),
      twitch: l({
        options: a,
        playerId: o
      }),
      vidyard: l({
        options: a
      })
    }),
    onReady: e,
    onStart: e,
    onPlay: e,
    onPause: e,
    onBuffer: e,
    onBufferEnd: e,
    onEnded: e,
    onError: e,
    onDuration: e,
    onSeek: e,
    onPlaybackRateChange: e,
    onPlaybackQualityChange: e,
    onProgress: e,
    onClickPreview: e,
    onEnablePIP: e,
    onDisablePIP: e
  }, r = () => {
  }, D = {
    playing: !1,
    loop: !1,
    controls: !1,
    volume: null,
    muted: !1,
    playbackRate: 1,
    width: "640px",
    height: "360px",
    style: {},
    progressInterval: 1e3,
    playsinline: !1,
    pip: !1,
    stopOnUnmount: !0,
    light: !1,
    fallback: null,
    wrapper: "div",
    previewTabIndex: 0,
    previewAriaLabel: "",
    oEmbedUrl: "https://noembed.com/embed?url={url}",
    config: {
      soundcloud: {
        options: {
          visual: !0,
          // Undocumented, but makes player fill container and look better
          buying: !1,
          liking: !1,
          download: !1,
          sharing: !1,
          show_comments: !1,
          show_playcount: !1
        }
      },
      youtube: {
        playerVars: {
          playsinline: 1,
          showinfo: 0,
          rel: 0,
          iv_load_policy: 3,
          modestbranding: 1
        },
        embedOptions: {},
        onUnstarted: r
      },
      facebook: {
        appId: "1309697205772819",
        version: "v3.3",
        playerId: null,
        attributes: {}
      },
      dailymotion: {
        params: {
          api: 1,
          "endscreen-enable": !1
        }
      },
      vimeo: {
        playerOptions: {
          autopause: !1,
          byline: !1,
          portrait: !1,
          title: !1
        },
        title: null
      },
      mux: {
        attributes: {},
        version: "2"
      },
      file: {
        attributes: {},
        tracks: [],
        forceVideo: !1,
        forceAudio: !1,
        forceHLS: !1,
        forceDASH: !1,
        forceFLV: !1,
        hlsOptions: {},
        hlsVersion: "1.1.4",
        dashVersion: "3.1.3",
        flvVersion: "1.5.0",
        forceDisableHls: !1
      },
      wistia: {
        options: {},
        playerId: null,
        customControls: null
      },
      mixcloud: {
        options: {
          hide_cover: 1
        }
      },
      twitch: {
        options: {},
        playerId: null
      },
      vidyard: {
        options: {}
      }
    },
    onReady: r,
    onStart: r,
    onPlay: r,
    onPause: r,
    onBuffer: r,
    onBufferEnd: r,
    onEnded: r,
    onError: r,
    onDuration: r,
    onSeek: r,
    onPlaybackRateChange: r,
    onPlaybackQualityChange: r,
    onProgress: r,
    onClickPreview: r,
    onEnablePIP: r,
    onDisablePIP: r
  };
  return y;
}
export {
  R as __require
};
